(function () {
  const styleTagId = "s6-styles";
  let timerStarted = false;

  function subscribePopupDelay() {
    if (timerStarted) return;
    timerStarted = true;
    ["scroll", "keydown", "touchstart"].forEach(function (event) {
      document.removeEventListener(event, subscribePopupDelay);
    });
    setTimeout(function () {
      const styleTag = document.getElementById(styleTagId);
      if (styleTag) styleTag.remove();
    }, 1000);
  }

  document.addEventListener("DOMContentLoaded", function () {
    ["scroll", "keydown", "touchstart"].forEach(function (event) {
      document.addEventListener(event, subscribePopupDelay);
    });
  });
})();